export const errorIds = {
  catalogPreview: {
    get: 'getCatalogPreviewError',
  },
  catalogCollection: {
    fetch: 'fetchCatalogCollectionError',
    create: 'createCatalogCollectionError',
    update: 'updateCatalogCollectionError',
    preview: 'previewCollectionError',
    delete: 'deleteCatalogCollectionError',
  },
};
